import styled from 'styled-components';

export const Section = styled.section`
  padding: 90px 0;
  overflow: hidden;
  background-color: #fafafa;
`;

export const List = styled.ul`
  display: block;
`;
